/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import BankTransferForm from 'containers/BankTransferForm'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getAccountsAndLoans, getBankTransferAccounts, setSelectedAccount } from 'actions/accountsAndLoans'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'
import { getPathName } from 'utils/getPathName'
import { getEmployeeId } from 'utils/getEmployeeId'

class PostAccountsAndLoans extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    bankTransferForm: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    getAccountsAndLoans: PropTypes.func.isRequired,
    getBankTransferAccounts: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    selectedPartner: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    selectedPartner: null,
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Accounts and Loans', this.props.history)

    this.props.getAccountsAndLoans(
      constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT,
      getEmployeeId(this.props.selectedPartner, this.props.currentUser),
    )
    this.props.getBankTransferAccounts(getEmployeeId(this.props.selectedPartner, this.props.currentUser))
  }

  handleOpenBankTransferForm = () => {
    this.props.modalShow('bankTransferForm')
  }

  handleSelectedAccount = (account) => {
    this.props.setSelectedAccount(account)
    const pathName = `${getPathName(this.props.currentUser, '/accountsandloans/transactions')}`
    this.props.history.push({ pathname: pathName })
  }

  render() {
    const {
      routes, accountsAndLoans, bankTransferForm, currentUser, selectedPartner,
    } = this.props
    return (
      <Container>
        {routes.map((route, i) => (
          <RouteWithSubRoutes
            key={i}
            {...route}
            accountType={constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT}
            accountsAndLoans={accountsAndLoans}
            bankTransferForm={bankTransferForm}
            currentUser={currentUser}
            openBankTransferForm={this.handleOpenBankTransferForm}
            selectedAccount={this.handleSelectedAccount}
            selectedPartner={selectedPartner}
            setErrorMessage={this.props.setErrorMessage}
          />
            ))}
        <BankTransferForm currentUser={currentUser} hide={this.props.modalHide} />
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  accountsAndLoans: state.accountsAndLoans,
  bankTransferForm: state.bankTransferForm,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getAccountsAndLoans,
  getBankTransferAccounts,
  setSelectedAccount,
  modalShow,
  modalHide,
})(PostAccountsAndLoans))



// WEBPACK FOOTER //
// ./src/containers/PostAccountsAndLoans.js